export default {
  async updatedUserData({rootGetters, dispatch}) {
    let userData = rootGetters['current_user/data']

    let date = new Date(userData.createdAt)
    let milliseconds = date.getTime();
    dispatch('mixpanelIdentify')
    dispatch('mixpanelSetUser', {
      $email: userData.email,
      $name: `${userData.firstName} ${userData.lastName}`,
      'Field 1': userData.field1,
      'Field 2': userData.field2,
      // don't get this data from api anymore
      // 'Spaces Count': userData.areas?.length,
      // 'Spaces Admin Count': userData.areaPermissions?.length,
      'Registered': milliseconds
    })
  },

  //admin
  async toggleUserSpaceAdmin({dispatch}, [user, type]) {
    dispatch('mixpanelTrack', ['Toggle User Admin', {
      'User': user,
      'User Type': type
    }])
  },
  async removeUserFromSpace({dispatch}, user) {
    dispatch('mixpanelTrack', ['Remove User From Space', {
      'User': user
    }])
  },
}
